import { render, staticRenderFns } from "./MathMinigame.vue?vue&type=template&id=76352298&scoped=true"
import script from "./MathMinigame.vue?vue&type=script&lang=js"
export * from "./MathMinigame.vue?vue&type=script&lang=js"
import style0 from "./MathMinigame.vue?vue&type=style&index=0&id=76352298&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76352298",
  null
  
)

export default component.exports